import type { RouteObject } from 'react-router';

const page = (name: string) => () =>
  import(`./pages/${name}.tsx`).then((m) => ({ Component: m[name] }));

/** 인증 라우트 — 레이아웃별(minimal / blank)로 분리해 라우터가 각 레이아웃 아래에 조립한다. */
export const authRoutes: { minimal: RouteObject[]; blank: RouteObject[] } = {
  minimal: [
    { path: 'login', lazy: page('LoginPage'), handle: { pageLabel: '로그인', title: '로그인' } },
    {
      path: 'signup',
      lazy: page('SignupPage'),
      handle: { pageLabel: '회원가입', title: '회원가입' },
    },
    {
      path: 'signup/verify-email',
      lazy: page('VerifyEmailSentPage'),
      handle: { title: '인증 메일 발송' },
    },
    { path: 'verify-email', lazy: page('VerifyEmailPage'), handle: { title: '이메일 인증' } },
    {
      path: 'verify-email/pending',
      lazy: page('VerifyEmailPendingPage'),
      handle: { title: '이메일 인증 대기' },
    },
    {
      path: 'password/forgot',
      lazy: page('ForgotPasswordPage'),
      handle: { pageLabel: '비밀번호 재설정', title: '비밀번호 재설정' },
    },
    {
      path: 'password/reset',
      lazy: page('ResetPasswordPage'),
      handle: { pageLabel: '비밀번호 재설정', title: '비밀번호 재설정' },
    },
    {
      path: 'error/auth-required',
      lazy: page('AuthRequiredPage'),
      handle: { title: '접근 권한 필요' },
    },
    {
      path: 'error/email-conflict',
      lazy: page('EmailConflictPage'),
      handle: { title: '이메일 중복' },
    },
    { path: 'error/verify', lazy: page('VerifyErrorPage'), handle: { title: '인증 오류' } },
  ],
  blank: [
    { path: 'auth/callback', lazy: page('SsoCallbackPage'), handle: { title: '로그인 처리 중' } },
  ],
};
